import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  didYouMean: {
    id: 'noresults.didyoumean',
    description: 'Text for a spelling suggestion',
    defaultMessage: 'Did you mean {suggestion} in {categoryName}?'
  },
  didYouMeanMessage: {
    id: 'noresults.didyoumean',
    description: 'Text for a spelling suggestion',
    defaultMessage: 'Did you mean {suggestion} in {categoryName}?'
  },
  suggestionsHeader: {
    id: 'noresults.suggestionsheader',
    description: 'Header for search suggestions',
    defaultMessage: 'Suggestions based on your search:'
  }
});
